module.exports = __webpack_public_path__ + "img/button-close.05046838.svg";